import styled from 'styled-components';
import LoadingMask from '../../../../CommonComponents/LoadingMask';

export const StyledLoadingMask = styled(LoadingMask).attrs(() => ({
  isDark: true,
  isRound: true,
}))`
  margin-bottom: 16px;
`;

export const LoadingArchiveButton = styled.div`
  display: flex;
  flex-direction: row;

  > * {
    margin-left: 12px;
  }
`;
